/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Deck_Upload_ForbiddenInputs */



/**
* | output |
* | --- |
* | "Only organizers or the player can upload a deck" |
*
* @param {Err_Tournament_Deck_Upload_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_deck_upload_forbidden = /** @type {((inputs?: Err_Tournament_Deck_Upload_ForbiddenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Deck_Upload_ForbiddenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuls les organisateurs ou le joueur peuvent télécharger un deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo los organizadores o el jugador pueden cargar un mazo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Somente organizadores ou o jogador podem enviar um deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo gli organizzatori o il giocatore possono caricare un deck")
	return /** @type {LocalizedString} */ ("Only organizers or the player can upload a deck")
});